// extracted by mini-css-extract-plugin
export default {"title":"LevelUpBonusChooser_title__L63ok","column":"LevelUpBonusChooser_column__Zx-6O"};